var _circle, _circle2, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2065,
    cy: 28.7031,
    r: 15.4439,
    fill: "#ECFFDE",
    stroke: "#58CC02",
    strokeWidth: 3.86098
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.2065,
    cy: 28.7032,
    r: 7.72196,
    fill: "#ECFFDE",
    stroke: "#58CC02",
    strokeWidth: 3.86098
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8118 14.509L35.7686 19.9406L34.7238 14.6533C34.701 14.3324 34.7486 13.9572 35.0303 13.74L40.5241 9.50341C40.9467 9.17751 41.4466 9.24327 41.774 9.66779C41.8831 9.8093 41.9377 9.88006 41.9218 10.0051L42.8118 14.509Z",
    fill: "#58A700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9032 15.9242L36.86 21.3557L41.7081 23.7099C42.0126 23.8135 42.3876 23.8628 42.6694 23.6455L48.1631 19.409C48.5857 19.0831 48.6491 18.5828 48.3218 18.1583C48.2126 18.0168 48.1581 17.946 48.0331 17.9296L43.9032 15.9242Z",
    fill: "#58A700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.6304,
    y: 28.3301,
    width: 23.3432,
    height: 2.57505,
    rx: 1.28753,
    transform: "rotate(-37.6382 24.6304 28.3301)",
    fill: "#478700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.39f13d2de304cad2ac2f88b31a7e2ff4.svg";
export { ForwardRef as ReactComponent };